import { Outlet } from 'react-router-dom';

const OnboardLayout = () => {
  return <Outlet />;
};

export default OnboardLayout;
